import React, { useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Form, Field } from 'react-final-form';
import FormField from '../checkout-steps/shared/form-field';
import CheckboxTermsAndAffidavit from '../shared/checkbox-terms-affidavit';
import loadingStyles from '../styles/components/loading.scss';

const { useState } = React;

const TransferDialog = ({
    intl, isOpen, handleClose, transferFunds, availableBalance = 1000, loading = false, ...props
}) => {
    const [handleCheck, setHandleCheck] = useState(false);

    const composeValidators = (...validators) => (value) => validators.reduce((error, validator) => error || validator(value), undefined);

    const amountValidator = () => (value) => (!Number.isNaN(value) && value > 0
        ? undefined
        : intl.formatMessage({ id: 'transfer-funds-k-wallet-invalid-amount-error', defaultMessage: 'Only numbers greater than zero are allowed. Use (.) to specify cents' }));
    const amountBelowValidator = () => (value) => (value <= availableBalance
        ? undefined
        : intl.formatMessage({ id: 'transfer-funds-k-wallet-available-balance-error', defaultMessage: 'You cannot transfer more than your available balance.' }));
    const requiredValidator = (value) => (value ? undefined : intl.formatMessage({ id: 'required-message', defaultMessage: 'Required' }));

    async function onSubmit(values) {
        transferFunds(values);
    }

    function handleOnChange(checked) {
        setHandleCheck(checked);
    }

    useEffect(() => {
        if (isOpen === false) {
            setHandleCheck(false);
        }
    }, [isOpen]);

    return (
        <Modal show={isOpen} aria-labelledby="contained-modal-title-lg">
            <Form
                onSubmit={onSubmit}
                render={({
                    handleSubmit, form, submitting, pristine, values, errors,
                }) => (
                    // eslint-disable-next-line react/jsx-fragments
                    <React.Fragment>
                        <form onSubmit={handleSubmit}>
                            <Modal.Header>
                                <Modal.Title id="contained-modal-title-lg">
                                    <FormattedMessage id="transfer-funds-k-wallet-title" defaultMessage="Enviar dinero a un receptor" />
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body style={{ overflow: 'auto' }}>
                                {loading && (
                                    <div className={loadingStyles.loadingPanel}>
                                        <div className={loadingStyles.spinnerDark} />
                                    </div>
                                )}
                                <div className="col-md-6 modal-form-top-space">
                                    <Field
                                        className="form-control"
                                        name="amount"
                                        component={FormField.inputFieldMarkup}
                                        label={intl.formatMessage({ id: 'transfer-funds-k-wallet-amount', defaultMessage: 'Cantidad a transferir' })}
                                        placeholder={intl.formatMessage({ id: 'transfer-funds-k-wallet-amount-placeholder', defaultMessage: 'Cantidad' })}
                                        type="tel"
                                        validate={composeValidators(requiredValidator, amountValidator(), amountBelowValidator())}
                                        focused
                                    />
                                </div>
                                <div className="col-md-6 modal-form-top-space">
                                    <Field
                                        className="form-control"
                                        name="idTransfer"
                                        label={intl.formatMessage({ id: 'transfer-funds-k-wallet-id-transfer', defaultMessage: 'Identificador de quien recibe' })}
                                        placeholder={intl.formatMessage({ id: 'transfer-funds-k-wallet-id-transfer-placeholder', defaultMessage: 'Id' })}
                                        component={FormField.inputFieldMarkup}
                                        type="text"
                                        validate={composeValidators(requiredValidator)}
                                    />
                                </div>
                                <div className="col-md-12 modal-form-top-space">
                                    <CheckboxTermsAndAffidavit onChange={handleOnChange} />
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <button
                                    disabled={!handleCheck || submitting || pristine || Object.keys(errors).length > 0 || loading}
                                    type="submit"
                                    style={{ marginRight: '5px' }}
                                    className="button-secondary button-small"
                                >
                                    <FormattedMessage id="send" defaultMessage="Send" />
                                </button>
                                <button
                                    disabled={loading}
                                    type="button"
                                    style={{ marginRight: '5px' }}
                                    className="button-secondary button-small"
                                    onClick={handleClose}
                                >
                                    <FormattedMessage id="modal-store-button-close" defaultMessage="Close" />
                                </button>
                            </Modal.Footer>
                        </form>
                    </React.Fragment>
                )}
            />
        </Modal>
    );
};

export default injectIntl(TransferDialog);



/** WEBPACK FOOTER **
 ** ./src/components/k-wallet/transfer-dialog.jsx
 **/